<div class="processing-warning-notification" data-qa-id="Processing Warning Notification">
  <em class="fa fa-spinner fa-pulse" aria-hidden="true"></em>
  <ng-content>Processing — please do not refresh, close, or navigate away from this page.</ng-content>
</div>
